export const phrases = {}
